import { Component, Input, Output, EventEmitter, OnInit, forwardRef, AfterViewInit,
   SimpleChanges, OnChanges, SimpleChange } from '@angular/core';
import { UspsService } from '@app/shared/services/usps.service';

// gre-toggle
@Component({
  selector: 'gre-address-validation',
  template: `
    <div class="content-group text-center">
    <h5> Verify your address</h5>
    <div *ngIf="!validatedAddress">
      <p>We could not find any matching address in USPS Database. </p>
      <p>Please edit your address, or use your original address. </p>
    </div>
    <div *ngIf="validatedAddress">
      <p>We found a matching address in USPS Database. </p>
      <p>Please choose which version of address you want to enter </p>
    </div>

  </div>

  <hr>
  <div class="row" >
    <div class="col-sm-6 text-center border-right-dashed wordWrap" *ngIf="addressToValidate">
      <h5>Original Address</h5>
      <p>{{addressToValidate.street | uppercase}}</p>
      <p>{{addressToValidate.city | uppercase }},{{addressToValidate.state | uppercase }}, {{addressToValidate.zip}}
      </p>
      <button class="btn btn-sm btn-warning" data-dismiss-modal="modal" (click)="useUnvalidatedAdress()">Use this Address</button>
    </div>
    <div class="col-sm-6 text-center" *ngIf="!validatedAddress">
      <h5>Suggested Address</h5>
      <p class="text-semibold">Address not found.</p>
      <p> Click <a (click)="changeAddress.emit()" class="text-semibold">here</a> to change it</p>
    </div>
    <div class="col-sm-6 text-center" *ngIf="validatedAddress">
      <h5>Suggested Address</h5>
      <p> {{validatedAddress.street}}</p>
      <p>{{validatedAddress.city}},{{validatedAddress.state}}, {{validatedAddress.zip}} </p>
      <button class="btn btn-sm btn-primary" data-dismiss-modal="modal" (click)="useValidatedAdress()"> Use this Address</button>
    </div>
  </div>
    `,
})
export class AddressValidationComponent implements OnInit {
  @Input('originalAddress') addressToValidate: any = null;
  @Input() validatedAddress: any = null;
  @Output() selectedAddress = new EventEmitter();
  @Output() changeAddress = new EventEmitter();
  // addressValidationError: any;
  constructor() { }
  ngOnInit(): void { }
  useValidatedAdress() { this.selectedAddress.emit(this.validatedAddress); }
  useUnvalidatedAdress() { this.selectedAddress.emit(this.addressToValidate); }
}
